import { PaidPlanRouteConfig } from '/src/modules/core/app/helpers/PaidPlanRouteConfig';

export class AccountingGenericRouteConfig extends PaidPlanRouteConfig {}
